import { useEffect, useRef, useState } from "react";

/**
 * Procentbar som alltid rör sig framåt.
 * Den kryper mjukt mot det aktuella stegets värde (och en bit förbi, så att den
 * aldrig ser ut att ha fastnat) och går till 100 % när allt är klart.
 */
export function useCreepingProgress(target: number, done: boolean): number {
  const [value, setValue] = useState(0);
  const valueRef = useRef(0);

  useEffect(() => {
    let raf = 0;
    let last =
      typeof performance !== "undefined" ? performance.now() : Date.now();

    const tick = (now: number) => {
      const dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      const goal = done ? 100 : Math.min(97, target + (100 - target) * 0.6);
      const speed = done ? 4 : 0.9;
      const next = valueRef.current + (goal - valueRef.current) * dt * speed;
      if (next > valueRef.current + 0.01) {
        valueRef.current = Math.min(100, next);
        setValue(valueRef.current);
      }
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, done]);

  return Math.round(value);
}
